import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './src/store/authStore';
import { Login } from './src/pages/Login';
import { AdminShell } from './src/components/AdminShell';
import { Dashboard } from './src/pages/Dashboard';
import { Users } from './src/pages/Users';
import { Devices } from './src/pages/Devices';
import { Sessions } from './src/pages/Sessions';
import { Alerts } from './src/pages/Alerts';
import { SyncLogs } from './src/pages/SyncLogs';
import { Content } from './src/pages/Content';
function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated,
    isLoading
  } = useAuth();
  if (isLoading) {
    return <div className="min-h-screen bg-background flex items-center justify-center text-white" data-id="element-0">
        Loading...
      </div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-1" />;
  }
  return <>{children}</>;
}
function PublicRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated,
    isLoading
  } = useAuth();
  if (isLoading) {
    return <div className="min-h-screen bg-background flex items-center justify-center text-white" data-id="element-2">
        Loading...
      </div>;
  }
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace data-id="element-3" />;
  }
  return <>{children}</>;
}
function AppRoutes() {
  return <Routes data-id="element-4">
      <Route path="/login" element={<PublicRoute data-id="element-6">
            <Login data-id="element-7" />
          </PublicRoute>} data-id="element-5" />

      <Route path="/" element={<ProtectedRoute data-id="element-9">
            <AdminShell data-id="element-10" />
          </ProtectedRoute>} data-id="element-8">
        <Route index element={<Navigate to="/dashboard" replace data-id="element-12" />} data-id="element-11" />
        <Route path="dashboard" element={<Dashboard data-id="element-14" />} data-id="element-13" />
        <Route path="users" element={<Users data-id="element-16" />} data-id="element-15" />
        <Route path="devices" element={<Devices data-id="element-18" />} data-id="element-17" />
        <Route path="sessions" element={<Sessions data-id="element-20" />} data-id="element-19" />
        <Route path="alerts" element={<Alerts data-id="element-22" />} data-id="element-21" />
        <Route path="sync-logs" element={<SyncLogs data-id="element-24" />} data-id="element-23" />
        <Route path="content" element={<Content data-id="element-26" />} data-id="element-25" />
      </Route>
    </Routes>;
}
export function App() {
  return <AuthProvider data-id="element-27">
      <BrowserRouter data-id="element-28">
        <AppRoutes data-id="element-29" />
      </BrowserRouter>
    </AuthProvider>;
}